import React from "react";
import PropTypes from "prop-types";
import { Spinner } from "react-bootstrap";
import "./Button.scss";

function Button(props) {
  const {
    label,
    className,
    isLoading,
    onClick,
    isTransparent,
    isYellowButton,
    ...rest
  } = props;
  let onClickWithLoadingPrevention;
  if (isLoading) {
    onClickWithLoadingPrevention = () => {};
  } else {
    onClickWithLoadingPrevention = onClick;
  }
  const transparentCls = isTransparent ? "transparent" : "";
  const yellowBtnCls = isYellowButton ? "yellow-btn" : "";
  return (
    <button
      className={`button ${className} ${transparentCls} ${yellowBtnCls}`}
      onClick={onClickWithLoadingPrevention}
      {...rest}
    >
      {isLoading ? (
        <Spinner className="button-spinner" animation="border" />
      ) : (
        label
      )}
    </button>
  );
}

Button.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  isLoading: PropTypes.bool,
  isTransparent: PropTypes.bool,
  isYellowButton: PropTypes.bool,
};

Button.defaultProps = {
  className: "",
  onClick: () => {},
  isLoading: false,
  isTransparent: false,
  isYellowButton: false,
};

export default Button;
